mutation PurchaseOrderItemDelete(
  $input: PurchaseOrderItemDeleteInput!
  $purchaseOrderId: UUID!
) {
  purchaseOrderItemDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
    query {
      purchaseOrder(id: $purchaseOrderId) {
        __typename
        id
        _rowTimestamp
        notesByEntityId(orderBy: _CREATED_DATE_DESC) {
          nodes {
            id
            _createdByUserName
            _createdDate
            noteComment
            isShared
            _isUpdatable
            _rowTimestamp
            _isDeletable
          }
        }
        purchaseOrderItems(orderBy: _SORT_ITEM_NUMBER_ASC) {
          nodes {
            id
            _rowTimestamp
            __typename
            purchaseOrderItemTypeId
            purchaseOrderItemType {
              calculationType
              layoutType
              abbreviation
              description
              id
            }
            itemNumber
            _isUpdatable
            _isDeletable
            itemExtendedAmount
            displayPoItemAccount
            displayPoItemQuantity
            displayPoItemUnitPrice
            displayPoItemTotal
            displayPoItemDescription
            displayPoItemRentalTerm
            displayPoItemType
            description
            isTaxable
            isDiscounted
            _extendedItemTotal
            itemQuantity
            itemRentalDates
            itemUnitPrice
            itemFromDate
            purchaseOrderItemType {
              layoutType
              abbreviation
            }
            _isActive
          }
        }
      }
    }
  }
}
